import DistributorsStore from "@shared/svelte/Stores/DistributorsStore";
import type { DistributorEmailDomainMatch } from "@shared/types/Distributor";

export const isValidDomain = (domain: string, distributorId: number) => {
  const matchedDistributorDomains: DistributorEmailDomainMatch[] =
    DistributorsStore.distributorDomains().filter((domainMatch: DistributorEmailDomainMatch) => {
      if (domainMatch.domain == domain) return domainMatch;
    });

  if (matchedDistributorDomains.length) {
    let distributorIds = matchedDistributorDomains.map(domainMatch => domainMatch.distributor_id);
    if (!distributorIds.includes(distributorId)) {
      return false;
    }
  }
  return true;
};
